export function getLocalVisibilityLabel(value) {
  if (value === null || value === undefined || value === "") return "Unavailable";
  if (typeof value === "string" && value.trim() === "") return "Unavailable";

  const numeric = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(numeric) || numeric < 0 || numeric > 100) return "Unavailable";
  if (numeric >= 75) return "Strong";
  if (numeric >= 50) return "Developing";
  return "Limited";
}
